import { Link } from "@amzn/awsui-components-react";
import { DlqRedriveRequestItem } from "../hooks/useDlqRedriveData";
import HealthStatusIndicator from "../../common/HealthStatusIndicator";
import { RedriveStatus } from "../../../types";

export const COLUMN_DEFINITIONS = [
  {
    id: "executionArn",
    header: "Execution ARN",
    cell: (item: DlqRedriveRequestItem) => (
      <Link
        href={`?stage=${encodeURIComponent(
          item.stage
        )}&executionArn=${encodeURIComponent(item.executionArn)}`}
      >
        {item.executionArn || "-"}
      </Link>
    ),
    sortingField: "executionArn",
  },
  {
    id: "status",
    header: "Status",
    width: 150,
    cell: (item: DlqRedriveRequestItem) => (
      <HealthStatusIndicator
        healthStatus={item.status as RedriveStatus}
      />
    ),
    sortingField: "status",
  },
  {
    id: "executionDate",
    header: "Start Date",
    width: 250,
    cell: (item: DlqRedriveRequestItem) =>
      item.executionDate ? new Date(item.executionDate).toLocaleString() : "-",
    sortingField: "executionDate",
  },
];
